
export default {
    title: 'Quản lý bán lẻ',
    api_url: process.env.REACT_APP_API_BASE_URL,
    home_url:  process.env.REACT_APP_PORTAL_URL,
    sub_system_id: 3
};
